import {DateTime} from "luxon";
import FollowUp from "../models/FollowUp";
import Interaction from "../models/Interaction";

export const formatDate = (date: Date | string): string => {
    const d = new Date(date);
    return d.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

export const getDateFromString = (dateString: string): Date => {
    return DateTime.fromISO(dateString).toJSDate();
}

export const formatFollowUpTime = (followUp: FollowUp): string | null => {
    if (!followUp.followUpTime) return null;
    const [hours, minutes = '00', ss = '00'] = followUp.followUpTime.split(':');
    return formatTime(hours, minutes, followUp.timeZone);
};

export const formatInteractionTime = (interaction: Interaction): string | null => {
    if (!interaction.interactionTime) return null;
    const [hours, minutes = '00', ss = '00'] = interaction.interactionTime.split(':');
    return formatTime(hours, minutes, interaction.timeZone);
};

const formatTime = (hours: string, minutes: string, timeZone: string | undefined): string | null => {
    const hours24 = parseInt(hours);
    const hours12 = ((hours24 + 11) % 12) + 1;
    const ampm = hours24 >= 12 ? 'PM' : 'AM';
    const timeZoneFormatted = timeZone ? `(${timeZone})` : '';
    return `${hours12}:${minutes.padStart(2, '0')} ${ampm} ${timeZoneFormatted}`;
}

export const getDefaultTimeZone = (): string => {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timeZone) return timeZone;
    } catch {}
    return 'America/New_York';
}

export const getTimeZones = (): string[] => {
    try {
        const list = Intl.supportedValuesOf('timeZone');
        if (Array.isArray(list) && list.length) return list;
    } catch {}
    return [
        'Pacific/Honolulu',
        'America/Anchorage',
        'America/Los_Angeles',
        'America/Denver',
        'America/Chicago',
        'America/New_York',
        'America/Toronto',
        'Europe/London',
        'Europe/Paris',
        'Europe/Berlin',
        'Europe/Oslo',
        'Europe/Warsaw',
        'Europe/Madrid',
        'Europe/Rome',
        'Asia/Dubai',
        'Asia/Kolkata',
        'Asia/Bangkok',
        'Asia/Shanghai',
        'Asia/Tokyo',
        'Australia/Sydney',
        'Pacific/Auckland',
        'UTC'
    ];
}